import React from 'react';
import { useTranslation } from 'react-i18next';

interface CoverInfoProps {
  sectionName: string;
  value?: string;
  className?: string;
  icon?: React.ReactNode;
}

const CoverInfo: React.FC<CoverInfoProps> = ({ sectionName, value, className, icon }) => {
  const { t } = useTranslation();

  return (
    <div className={`cover-info ${sectionName} ${className}`} style={{ gridArea: sectionName }}>
      {icon ? icon : <span className="cover-info-title">{t(`pdf:cover.${sectionName}`, '')}:</span>}
      <span className="cover-info-value">{value}</span>
    </div>
  );
};

export default CoverInfo;
